// Auth feature API.
// `createAuthApi(client)` returns auth methods bound to a shared ApiClient
// instance, so session state and listeners stay on one object.
export function createAuthApi(client) {
  return {
    async signInWithPassword({ email, password }) {
      const result = await client.call('/auth', {
        method: 'POST',
        body: JSON.stringify({ action: 'signin', email, password }),
        _skipAuth: true
      })
      client.setSession(result.session)
      return { data: { session: result.session }, error: null }
    },

    async signUp({ email, password, options }) {
      const result = await client.call('/auth', {
        method: 'POST',
        body: JSON.stringify({ action: 'signup', email, password, options }),
        _skipAuth: true
      })
      client.setSession(result.session)
      return { data: result, error: null }
    },

    async signOut() {
      await client.call('/auth', {
        method: 'POST',
        body: JSON.stringify({ action: 'signout' }),
        _skipAuth: true
      })
      client.setSession(null)
      return { error: null }
    },

    async signInWithOAuth({ provider, redirectTo }) {
      const result = await client.call('/auth', {
        method: 'POST',
        body: JSON.stringify({ action: 'oauth', provider, redirectTo }),
        _skipAuth: true
      })
      return { data: result, error: null }
    },

    async getUserByToken(accessToken) {
      const result = await client.call('/auth', {
        method: 'POST',
        body: JSON.stringify({ action: 'getUser', accessToken }),
        _skipAuth: true
      })
      return { data: { user: result.user }, error: null }
    },

    async getSession() {
      if (!client.session) return { data: { session: null }, error: null }
      if (client._isTokenExpired(client.session.access_token)) {
        const refreshed = await client._refresh()
        return { data: { session: refreshed }, error: null }
      }
      return { data: { session: client.session }, error: null }
    },

    async refreshSession(refreshToken) {
      const result = await client.call('/auth', {
        method: 'POST',
        body: JSON.stringify({ action: 'refreshSession', refreshToken }),
        _skipAuth: true
      })
      if (result.session) client.setSession(result.session)
      return { data: result, error: null }
    },

    async resetPasswordForEmail(email, options) {
      await client.call('/auth', {
        method: 'POST',
        body: JSON.stringify({ action: 'resetPassword', email, redirectTo: options.redirectTo }),
        _skipAuth: true
      })
      return { error: null }
    }
  }
}
